import { Button } from "@/components/ui/button";
import {
  availablePaymentMethods,
  type PaymentMethodId,
} from "@/lib/paymentMethods";

export interface PaymentMethodSelectorProps {
  value: PaymentMethodId;
  acceptedPaymentMethods: PaymentMethodId[];
  onChange: (paymentMethodId: PaymentMethodId) => void;
}

export default function PaymentMethodSelector({
  value,
  acceptedPaymentMethods,
  onChange,
}: PaymentMethodSelectorProps) {
  const methods = availablePaymentMethods(acceptedPaymentMethods);

  if (methods.length <= 1) {
    return null;
  }

  return (
    <fieldset className="space-y-2 border-t border-primary-100 pt-4 dark:border-primary-800">
      <legend className="text-sm font-light text-primary-900 dark:text-white">
        Forma de pagamento
      </legend>
      <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Forma de pagamento">
        {methods.map((method) => (
          <Button
            key={method.id}
            type="button"
            role="radio"
            variant={value === method.id ? "default" : "outline"}
            size="sm"
            className="font-light normal-case tracking-normal"
            aria-checked={value === method.id}
            onClick={() => onChange(method.id)}
          >
            {method.label}
          </Button>
        ))}
      </div>
    </fieldset>
  );
}
